<div class="wrapper">
  @if (user | async; as user) {
    <div class="user-info" title="{{ user.email }}">
      <div>{{ user.email }}</div>
      <div>({{ user.provider }})</div>
    </div>
  }
  <nav>
    <ul>
      <li>
        <app-button variant="basic" (buttonClick)="showProfile()">
          <span><img src="icons/profile.svg" i18n-alt alt="profile" /><span i18n>User profile</span></span>
        </app-button>
      </li>
      <li>
        <app-button variant="basic">
          <app-link variant="basic" href="https://www.agcocorp.com/int/en/home/privacy-center.html">
            <span><img src="icons/policy.svg" i18n-alt alt="policy" /><span i18n>Privacy policy</span></span>
          </app-link>
        </app-button>
      </li>
      <li>
        <app-button variant="basic" (buttonClick)="showCookies()">
          <span><img src="icons/cookie.svg" i18n-alt alt="cookie" /><span i18n>Cookie preferences</span></span>
        </app-button>
      </li>
      <li>
        <img src="icons/globe.svg" i18n-alt alt="globe" />
        <app-language-selector />
      </li>
      <li>
        <app-button variant="basic" (buttonClick)="logout()">
          <span><img src="icons/logout.svg" i18n-alt alt="logout" /><span i18n>Log out</span></span>
        </app-button>
      </li>
    </ul>
  </nav>
  <img class="logo" src="agco-logo.png" i18n-alt alt="logo" />
</div>
